export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_09.b5cacffd.png";